import cn from "classnames";
import { Button } from "components/Button/Button";
import { useEffect, useRef, useState } from "react";
import "./index.css";

export const TextCompletion = ({ text = "", onComplete, time }) => {
  const [blankHash, setBlankHash] = useState({});
  const [minLengthError, setMinLengthError] = useState(false);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (time !== null && time < 1) {
      generateSentance();
    }
  }, [time]);

  const checkBlankInputMinLength = Object.values(blankHash)
    .every(value => value.trim().length >= 2);

  const blankChangeHandler = (index, value) => {
    if (minLengthError) setMinLengthError(false);
    setBlankHash((prevState) => ({ ...prevState, [index]: value }));
  };

  const generateSentance = () => {
    if (!checkBlankInputMinLength) {
      setMinLengthError(true);
      return;
    } else setMinLengthError(false);
    setLoading(true)
    const answerText = text
      .split("[blank]")
      .reduce((sentence, text, index, arr) => {
        const isLastIndex = index === arr.length - 1;
        if (isLastIndex) {
          return sentence + text;
        }

        return sentence + text + blankHash[index].trim();
      }, "");

    onComplete({ answerText }, true, false, true);
  };

  const isAllBlanksFilled = (text.match(/\[blank\]/g) || []).every(
    (_, index, arr) => !!blankHash[index]
  );

  return (
    <div className="flex h-full w-full flex-col items-center justify-between gap-10 py-7 sm:gap-0 sm:py-0">
      <div className="flex w-full flex-1 flex-col items-center gap-10">
        <h4 className="text-center text-[26px] font-medium text-cocoa-brown">
          Type the missing words
        </h4>
        <p
          className={cn(
            "w-full flex-1 break-word rounded-[10px] bg-[#4528120a] px-5 py-5 text-left text-xl font-medium text-[#93857B] transition-all",
            "sm:flex-initial sm:py-7 sm:text-3xl"
          )}
        >
          {text.split("[blank]").map((text, index, arr) => (
            <>
              <span>{text}</span>
              {index !== arr.length - 1 && (
                <Blank
                  index={index}
                  value={blankHash[index]}
                  onChange={blankChangeHandler}
                />
              )}
            </>
          ))}

        </p>
        {
          minLengthError &&
          <p className="text-xl text-center text-red-500">Please add more than 1 character.</p>
        }
      </div>

      <Button
        onClick={generateSentance}
        disabled={!isAllBlanksFilled || loading}
        className="bg-cocoa-brown text-white"
      >
        Next
      </Button>
    </div>
  );
};

const Blank = ({ index, value, onChange }) => {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  return (
    <>
      <span
        className={cn(
          "inline-block min-h-[25px] sm:min-h-[36px] min-w-[130px] cursor-text border-b-2 border-black align-bottom text-black transition-all",
          {
            blinker: focused,
            "border-solid": focused || value,
            "border-dashed opacity-50": !(focused || value),
          }
        )}
        onClick={() => inputRef.current?.focus()}
      >
        {value}
      </span>
      <input
        value={value}
        ref={inputRef}
        type="text"
        autoCorrect="off"
        className="absolute -top-full -left-full"
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={({ target }) => onChange(index, target.value)}
      />
    </>
  );
};
